/**
* 左边菜单
*/

<template>
    <el-menu :default-active="$route.path" :collapse="collapsed" collapse-transition router unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
        <div class="logobox">
            <h1 v-if="!collapsed">数据中台管理后台</h1>
            <img v-else class="logoimg" src="../../../public/static/image/logo.png" alt="">
        </div>
        <template v-for="menu in menuList">
            <el-menu-item :index="menu.url" v-if="!menu.children" :key="menu.menuid">
                <i :class="menu.icon"></i>
                <span slot="title">{{menu.menuname}}</span>
            </el-menu-item>
            <el-submenu :index="menu.url.toString()" v-else :key="menu.menuid">
                <template slot="title">
                    <i :class="menu.icon"></i>
                    <span>{{menu.menuname}}</span>
                </template>
                <el-menu-item :index="item.url" v-for="item in menu.children" :key="item.menuid">
                    <i :class="item.icon"></i>
                    <span slot="title">{{item.menuname}}</span>
                </el-menu-item>
            </el-submenu>
        </template>
    </el-menu>
</template>
<script>
    import storage from '../../common/storage'
    export default {
        name: 'leftnav',
        data() {
            return {
                allmenu: [],
                menuList: [{
                        menuid: 1,
                        icon: 'el-icon-s-custom',
                        menuname: '用户管理',
                        hasThird: null,
                        url: '/userManage',
                    },
                    {
                        menuid: 2,
                        icon: 'el-icon-school',
                        menuname: '单位管理',
                        url: '/unitManage',
                    },
                    {
                        menuid: 9,
                        icon: 'el-icon-present',
                        menuname: '钉钉管理',
                        hasThird: null,
                        url: '/dingdingManage',
                    },
                    {
                        menuid: 3,
                        icon: 'el-icon-mobile-phone',
                        menuname: '设备管理',
                        hasThird: null,
                        url: '/deviceManage',
                    },
                    {
                        menuid: 4,
                        icon: 'el-icon-setting',
                        menuname: '配置项管理',
                        hasThird: null,
                        url: '/settingManage',
                    },
                    {
                        menuid: 5,
                        icon: 'el-icon-microphone',
                        menuname: '翻译管理',
                        hasThird: null,
                        url: '/translateManage',
                    },
                    {
                        menuid: 6,
                        icon: 'el-icon-lock',
                        menuname: '授权管理',
                        hasThird: null,
                        url: '/authorizeManage',
                    },
                    {
                        menuid: 7,
                        icon: 'el-icon-document',
                        menuname: '日志管理',
                        hasThird: null,
                        url: '/LogManage',
                        children: [{
                                menuid: 7 - 1,
                                icon: 'el-icon-tickets',
                                menuname: '接口日志',
                                hasThird: null,
                                url: '/operationList',
                            },
                            {
                                menuid: 7 - 2,
                                icon: 'el-icon-document-delete',
                                menuname: '错误日志',
                                hasThird: null,
                                url: '/errorList',
                            },
                        ]
                    },
                    {
                        menuid: 8,
                        icon: 'el-icon-shopping-bag-1',
                        menuname: '应用管理',
                        hasThird: null,
                        url: '/appManage',
                    },
                    {
                        menuid: 10,
                        icon: 'el-icon-discount',
                        menuname: '标签管理',
                        hasThird: null,
                        url: '/tagManage',
                    },
                    // {
                    //     menuid: 9,
                    //     icon: 'el-icon-printer',
                    //     menuname: '应用类型管理',
                    //     hasThird: null,
                    //     url: '/appTypeManage',
                    // },
                    //     {
                    //     path: '/appTypeManage',
                    //     name: 'appTypeManage',
                    //     meta: {
                    //         title: '应用类型管理',
                    //     },
                    //     component: () =>
                    //         import ('./components/appTypeManage/list.vue')
                    // },
                ],
            }
        },
        props: {
            collapsed: {
                required: true,
                type: Boolean
            }
        },
        created() {
            let res = {
                success: true,
                msg: 'success'
            }
            this.allmenu = res.data
        },
        mounted() {
            let userinfo = JSON.parse(storage.getSession('userinfo'))
            let UserId = userinfo.Uid;
            if (UserId != 'admin') {
                this.menuList.shift();
            }
        },
        methods: {

        }
    }
</script>
<style>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 240px;
        min-height: 400px;
    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        border: none;
        text-align: left;
    }

    .el-menu-item-group__title {
        padding: 0px;
    }

    .el-aside {
        width: auto !important;
    }

    .el-menu-bg {
        background-color: #1f2d3d !important;
    }

    .el-menu {
        border: none;
        height: 100%;
    }

    .logobox {
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
        padding: 20px 0px;
        background-color: rgba(255, 255, 255, .2);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logoimg {
        height: 40px;
    }
</style>